import palette from '@lib/core/src/theme/palette';
import { alpha } from '@mui/material';

const exitAnimationParams = {
  x: 1500,
  y: 100,
  rotate: 25,
  duration: 0.3
};

export enum AnimationT {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Initial = 'initial',
  Entered = 'entered',
  Straight = 'straight'
}

export const firstQuickActionVariants = {
  [AnimationT.Initial]: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    x: 0,
    y: 0,
    transition: {
      duration: exitAnimationParams.duration
    }
  },
  [AnimationT.Entered]: {
    scale: 1,
    rotate: 0,
    x: 0,
    y: 0,
    transition: {
      scale: {
        duration: exitAnimationParams.duration,
        ease: 'easeOut'
      },
      rotate: {
        duration: exitAnimationParams.duration
      }
    }
  },
  [AnimationT.Top]: {
    y: -exitAnimationParams.x,
    transition: { duration: exitAnimationParams.duration }
  },
  [AnimationT.Left]: {
    x: -exitAnimationParams.x,
    y: -exitAnimationParams.y,
    rotate: -exitAnimationParams.rotate,
    transition: {
      duration: exitAnimationParams.duration
    }
  },
  [AnimationT.Right]: {
    x: exitAnimationParams.x,
    y: -exitAnimationParams.y,
    rotate: exitAnimationParams.rotate,
    transition: { duration: exitAnimationParams.duration }
  }
};

export const secondQuickActionVariants = {
  [AnimationT.Initial]: {
    background: alpha(palette.black, 0.2),
    backdropFilter: 'blur(10px)',
    height: '100%',
    top: -20,
    left: 0,
    opacity: 0.5,
    scale: 0.95,
    rotate: 0,
    transition: {
      duration: exitAnimationParams.duration,
      delay: exitAnimationParams.duration
    }
  },
  [AnimationT.Straight]: {
    background: palette.white,
    backdropFilter: 'blur(0px)',
    height: '100%',
    top: 0,
    left: 0,
    scale: 1,
    rotate: 0,
    opacity: 1,
    transition: {
      duration: exitAnimationParams.duration,
      height: {
        duration: 0
      },
      background: {
        duration: exitAnimationParams.duration / 2
      },
      backdropFilter: {
        duration: exitAnimationParams.duration
      }
    }
  }
};
